import { ContentList } from '../components/ContentList';

import { useDepartmentStore } from '@/stores/department';

export const ContentPage = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <ContentList department={department} />;
};
